import { isPlainObject } from 'bundles/recommendations-explainer/utils/candidateId';

export const parseKeyPrograms = (value: unknown): ReadonlyArray<{ id: string }> | null | undefined => {
  if (value === null) {
    return null;
  }

  if (!isPlainObject(value)) {
    return undefined;
  }

  const programIds = value.id;
  if (programIds === null) {
    return null;
  }

  if (!Array.isArray(programIds) || !programIds.every((id): id is string => typeof id === 'string')) {
    return undefined;
  }

  return programIds.map((id) => ({ id }));
};
